var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28261 2.91309H59.7174C63.7374 2.91309 67 6.17569 67 10.1957V17.4783H0V10.1957C0 6.17569 3.26261 2.91309 7.28261 2.91309Z",
    fill: "url(#paint0_linear_1429_5204)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85352 25.623H61.1456V58.0771C61.1456 61.3946 58.4531 64.0871 55.1356 64.0871H11.8635C8.546 64.0871 5.85352 61.3946 5.85352 58.0771V25.623Z",
    fill: "url(#paint1_linear_1429_5204)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.4482H67V56.7743C67 60.7943 63.7374 64.0569 59.7174 64.0569H7.28261C3.26261 64.0569 0 60.7943 0 56.7743V17.4482Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.4482H67V56.7743C67 60.7943 63.7374 64.0569 59.7174 64.0569H7.28261C3.26261 64.0569 0 60.7943 0 56.7743V17.4482Z",
    fill: "url(#paint2_linear_1429_5204)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6 18.0482H66.4V56.7743C66.4 60.463 63.406 63.4569 59.7174 63.4569H7.28261C3.59398 63.4569 0.6 60.463 0.6 56.7743V18.0482Z",
    stroke: "url(#paint3_linear_1429_5204)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_1429_5204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73922 13.1083C10.348 13.1083 11.6523 11.8041 11.6523 10.1953C11.6523 8.58644 10.348 7.28223 8.73922 7.28223C7.13039 7.28223 5.82617 8.58644 5.82617 10.1953C5.82617 11.8041 7.13039 13.1083 8.73922 13.1083Z",
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9349 13.1083C20.5437 13.1083 21.8479 11.8041 21.8479 10.1953C21.8479 8.58644 20.5437 7.28223 18.9349 7.28223C17.326 7.28223 16.0218 8.58644 16.0218 10.1953C16.0218 11.8041 17.326 13.1083 18.9349 13.1083Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_1429_5204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.228 23.4214L44.2282 37.4215C44.3611 37.5259 44.4801 37.6469 44.5822 37.7816C44.9055 38.2002 45.0497 38.7299 44.9834 39.2547C44.917 39.7794 44.6455 40.2565 44.2282 40.5816L26.228 54.5817C25.9324 54.8117 25.5781 54.954 25.2056 54.9925C24.833 55.031 24.4572 54.9641 24.1208 54.7995C23.7844 54.6348 23.5009 54.379 23.3028 54.0612C23.1047 53.7433 22.9997 53.3763 23 53.0017V35.0015V25.0014C22.9997 24.6269 23.1047 24.2598 23.3028 23.942C23.5009 23.6241 23.7844 23.3683 24.1208 23.2036C24.4572 23.039 24.833 22.9721 25.2056 23.0106C25.5781 23.0491 25.9324 23.1914 26.228 23.4214Z",
    fill: "white",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8596 23.895L25.8597 23.895L43.8576 37.8934C43.858 37.8937 43.8583 37.894 43.8587 37.8942C43.9508 37.9668 44.0334 38.0508 44.1042 38.1442L44.1042 38.1442L44.1073 38.1482C44.3336 38.4413 44.4345 38.8121 44.3881 39.1794C44.3417 39.5467 44.1516 39.8807 43.8595 40.1083L25.8597 54.1081L25.8596 54.1082C25.6527 54.2691 25.4047 54.3688 25.1439 54.3957C24.8831 54.4227 24.62 54.3758 24.3845 54.2606C24.1491 54.1453 23.9507 53.9663 23.812 53.7438C23.6733 53.5213 23.5998 53.2643 23.6 53.0021V53.0017V35.0015L23.6 25.0014L23.6 25.001C23.5998 24.7388 23.6733 24.4819 23.812 24.2594C23.9507 24.0369 24.1491 23.8578 24.3845 23.7426C24.62 23.6273 24.8831 23.5805 25.1439 23.6074C25.4047 23.6344 25.6527 23.734 25.8596 23.895Z",
    stroke: "url(#paint4_linear_1429_5204)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5204",
    x: -24,
    y: -6.55176,
    width: 115,
    height: 94.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5204",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_1429_5204",
    x: -18.1738,
    y: -16.7178,
    width: 64.0215,
    height: 53.8262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5204",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_1429_5204",
    x: -1,
    y: -1,
    width: 69.999,
    height: 80.0029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5204"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5204",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5204",
    x1: 2.79167,
    y1: 5.82613,
    x2: 55.6574,
    y2: 39.6015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5204",
    x1: 8.15735,
    y1: 33.3159,
    x2: 67.238,
    y2: 45.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5204",
    x1: 2.79167,
    y1: 26.77,
    x2: 74.3824,
    y2: 41.0633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5204",
    x1: 2.09375,
    y1: 19.5668,
    x2: 67,
    y2: 19.5668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1429_5204",
    x1: 23.6875,
    y1: 24.4547,
    x2: 44.9992,
    y2: 24.4547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb3);
export default __webpack_public_path__ + "static/media/web3.d08aff1f7867dd543fd0f042e5006572.svg";
export { ForwardRef as ReactComponent };